import React, { useEffect, useState } from 'react';
import { Card, Button, Form, Input, Select, message, Radio, Row, Col, Checkbox } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import axios from '../util/axiosConfig';
import '../styles/common.css';

import { useInvContext } from '../context/InvContext';

const { Option } = Select;


const AddEditUser: React.FC = () => {
    // const { plants, poDocType, purchaseGroup, roles } = useInvContext();
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();
    const [selectedPlants, setSelectedPlants] = useState<string[]>([]);
    const [selectedDocType, setSelectedDocType] = useState<string[]>([]);
    const [selectedPurchaseGroup, setSelectedPurchaseGroup] = useState<string[]>([]);
    const [plants, setPlantlist] = useState<any[]>([]);
    const [poDocType, setDocumentlist] = useState<any[]>([]);
    const [purchaseGroup, setPurchaselist] = useState<any[]>([]);
    const [roles, setRolelist] = useState<any[]>([]);
    const [planterrorMessage, setplantErrorMessage] = useState<string | null>(null);
    const [docerrorMessage, setdocErrorMessage] = useState<string | null>(null);
    const [purchaseerrorMessage, setpurchaseErrorMessage] = useState<string | null>(null);

    const fetchUserData = async () => {
        try {
            const response = await axios.get(`/api/v1/user/get-user/${id}`);
            const userData = response?.data?.data;

            // Map IDs to display values
            const mapIdsToValues = (ids: number[], options: any[]) =>
                options.filter(option => ids.includes(option.id)).map(option => option.id.toString());

            form.setFieldsValue({
                name: userData.username,
                email: userData.email,
                role: userData.roleId[0],
                plants: userData.plantId,
                docType: userData.poDocumentTypeId,
                purchaseGroup: userData.purchaseGroupId,
                lineItemsDeleteAccess: userData.lineItemsDeleteAccess ? 'true' : 'false',
                duplicateInvoiceDeleteAccess: userData.duplicateInvoiceDeleteAccess ? 'true' : 'false',
                status: userData.active ? 'Active' : 'Inactive',
            });
            setSelectedPlants(userData.plantId);
            setSelectedDocType(userData.poDocumentTypeId);
            setSelectedPurchaseGroup(userData.purchaseGroupId);
        } catch (error) {
            console.error('Failed to fetch user data:', error);
            message.error('Failed to fetch user data');
        }
    };
    const fetchPlantList = async () => {
        try {
            const response = await axios.get(`/plant/get-all-plants`, {
            });
            if (response?.data) {
                setPlantlist(response?.data?.data)

            }
        } catch (error) {
            console.error('Failed to fetch invoice data:', error);
        }
    }

    const fetchDocumentList = async () => {
        try {
            const response = await axios.get(`/po-document-type/get-all-po-document-type`, {
            });
            if (response?.data) {
                setDocumentlist(response?.data?.data)

            }
        } catch (error) {
            console.error('Failed to fetch invoice data:', error);
        }
    }

    const fetchPurchaseList = async () => {
        try {
            const response = await axios.get(`/purchase-group/get-all-purchase-group`, {
            });
            if (response?.data) {
                setPurchaselist(response?.data?.data)

            }
        } catch (error) {
            console.error('Failed to fetch invoice data:', error);
        }
    }
    const fetchRoleList = async () => {
        try {
            const response = await axios.get(`/roles/get-all-roles`, {
            });
            if (response?.data) {
                setRolelist(response?.data?.data)

            }
        } catch (error) {
            console.error('Failed to fetch Role data:', error);
        }
    }
    useEffect(() => {
        fetchPlantList();
        fetchDocumentList();
        fetchPurchaseList();
        fetchRoleList();
        if (id) {
            fetchUserData();
        } else {
            form.setFieldsValue({
                lineItemsDeleteAccess: 'false',
                duplicateInvoiceDeleteAccess: 'false',
                status: 'Active',
            });
        }
    }, [id, form]);

    const handleSubmit = async (values: any) => {
        // if (selectedPlants.length === 0) {
        //     setplantErrorMessage('Please select at least one plant');
        //     return
        // } else {
        //     setplantErrorMessage(null)
        // }
        if (selectedDocType.length === 0) {
            setdocErrorMessage('Please select at least one doc type');
            return
        } else {
            setdocErrorMessage(null)
        }
        if (selectedPurchaseGroup.length === 0) {
            setpurchaseErrorMessage('Please select at least one purchase group');
            return
        } else {
            setpurchaseErrorMessage(null)
        }
        const payload = {
            id: id || 0,
            username: values.name,
            email: values.email,
            roleId: [values.role],
            serialNo: 0,
            plantId: selectedPlants ? selectedPlants : [],
            poDocumentTypeId: selectedDocType,
            purchaseGroupId: selectedPurchaseGroup,
            lineItemsDeleteAccess: values.lineItemsDeleteAccess === 'true',
            duplicateInvoiceDeleteAccess: values.duplicateInvoiceDeleteAccess === 'true',
            active: values.status === 'Active',
        };

        try {
            let response;
            if (id) {
                response = await axios.put(`/api/v1/user/update-user`, payload, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
            } else {
                response = await axios.post('/api/v1/user/create-user', payload, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
            }
            if (response.status === 200) {
                message.success(id ? 'User updated successfully' : 'User added successfully');
                navigate('/user-list');
            } else {
                message.error('Failed to submit user');
            }
        } catch (error) {
            message.error('Error occurred while submitting user');
        }
    };


    const handlePlantChange = (values: string[]) => {
        if (values.includes('all')) {
            if (selectedPlants.length === plants.length) {
                setTimeout(() => {
                    setSelectedPlants([]); // Deselect all
                }, 300);

            } else {
                setSelectedPlants(plants.map(option => option.id));
                setplantErrorMessage(null)
            }
        } else {
            // Set the selected options (excluding "Select All")
            setSelectedPlants(values);
            setplantErrorMessage(null)

        }
    };

    const handleDocTypeChange = (values: string[]) => {
        if (values.includes('all')) {
            if (selectedDocType.length === poDocType.length) {
                setTimeout(() => {
                    setSelectedDocType([]); // Deselect all
                }, 300);

            } else {
                setSelectedDocType(poDocType.map(option => option.id));
                setdocErrorMessage(null)

            }
        } else {
            setSelectedDocType(values);
            setdocErrorMessage(null)

        }
    };

    const handlePurchaseGroupChange = (values: string[]) => {
        if (values.includes('all')) {
            // If "Select All" is selected, select all options
            if (selectedPurchaseGroup.length === purchaseGroup.length) {
                setTimeout(() => {
                    setSelectedPurchaseGroup([]); // Deselect all
                }, 300);

            } else {
                setSelectedPurchaseGroup(purchaseGroup.map(option => option.id));
                setpurchaseErrorMessage(null)

            }
        } else {
            // Set the selected options (excluding "Select All")
            setSelectedPurchaseGroup(values);
            setpurchaseErrorMessage(null)

        }
    };

    const reorderOptions = (
        selectedItems: number[],
        options: any[],
        labelKey: string,
        secondaryLabelKey: string
    ) => {
        const selectedObjects = options.filter(option =>
            selectedItems.includes(option.id)
        );

        const unselectedObjects = options.filter(option =>
            !selectedItems.includes(option.id)
        );

        return [...selectedObjects, ...unselectedObjects].map(option => (
            <Option
                key={option.id}
                value={option.id.toString()}
                label={`${option[labelKey]} - ${option[secondaryLabelKey]}`}
            >
                <Checkbox checked={selectedItems.includes(option.id)}>
                    {`${option[labelKey]} - ${option[secondaryLabelKey]}`}
                </Checkbox>
            </Option>
        ));
    };

    return (
        <>
            <Card bordered={false} title={id ? "Masters - Edit User" : "Masters - Add User"}>
                <Row>
                    <Col span={10}>
                        <Form form={form} layout="vertical" onFinish={handleSubmit}>
                            <Form.Item name="name" label="Name" rules={[{ required: true, message: 'Please enter the name' }]}>
                                <Input placeholder="Enter name" />
                            </Form.Item>

                            <Form.Item name="email" label="Email" rules={[{ required: true, message: 'Please enter the email' }]}>
                                <Input placeholder="Enter email" />
                            </Form.Item>

                            <Form.Item
                                name="role"
                                label="User Role"
                                rules={[{ required: true, message: 'Please select a role' }]}
                            >
                                <Select placeholder="Select role">
                                    {roles.map((role) => (
                                        <Option key={role.id} value={role.id}>
                                            {role.name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>

                            {/* <Form.Item name="plants" label="Plant" rules={[{ required: true, message: 'Please select at least one plant' }]}> */}
                            {/* <Select
                                    mode="multiple"
                                    placeholder="Search and select Plant"
                                    optionLabelProp="label"
                                    showSearch
                                    allowClear
                                    value={selectedPlants.map(id => id.toString())}
                                    onChange={handlePlantChange}
                                    filterOption={(input, option) =>
                                        (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                    }
                                >
                                    {reorderOptions(selectedPlants, plants, 'name', 'code')}
                                </Select> */}
                            {/* <div className='user_selectfields'>
                                <span className='requiredStar'>* </span><label className='userSelectLabels'>Plant</label>
                                <Select mode="multiple" value={selectedPlants} onChange={handlePlantChange} optionFilterProp="key">
                                    <option key="all" value="all">
                                        {selectedPlants?.length === plants?.length ? 'Un Select All' : 'Select All'}
                                    </option>
                                    {plants.map((Plant) => (
                                        <option key={Plant.name} value={Plant.id}>
                                            {Plant.name} 
                                        </option>
                                    ))}
                                </Select>
                                {planterrorMessage && <div style={{ color: 'red', marginTop: 5 }}>{planterrorMessage}</div>}
                            </div> */}
                            {/* <Select mode="multiple" value={selectedPlants} onChange={handlePlantChange} optionFilterProp="key">
                                    <option key="all" value="all">
                                        {selectedPlants?.length === plants?.length ? 'Un Select All' : 'Select All'}
                                    </option>
                                    {plants.map((Plant) => (
                                        <option key={Plant.name} value={Plant.id}>
                                            {Plant.name}
                                        </option>
                                    ))}
                                </Select> */}
                            {/* </Form.Item> */}

                            {/* <Form.Item name="docType" label="Doc Type" rules={[{ required: true, message: 'Please select document types' }]}>
                                <Select mode="multiple" value={selectedDocType} onChange={handleDocTypeChange} optionFilterProp="key">

                                    {poDocType.map((Document) => (
                                        <option key={Document.docType} value={Document.id}>
                                            {Document.docType}
                                        </option>
                                    ))}
                                </Select>
                            </Form.Item> */}
                            <div className='user_selectfields'>
                                <span className='requiredStar'>* </span><label className='userSelectLabels'>Doc Type</label>
                                <Select mode="multiple" value={selectedDocType} onChange={handleDocTypeChange} optionFilterProp="key">
                                    <option key="all" value="all">
                                        {selectedDocType?.length === poDocType?.length ? 'Un Select All' : 'Select All'}
                                    </option>
                                    {poDocType?.map((Document) => (
                                        <option key={Document.docType} value={Document.id}>
                                            {Document.docType}
                                        </option>
                                    ))}
                                </Select>
                                {docerrorMessage && <div style={{ color: 'red', marginTop: 5 }}>{docerrorMessage}</div>}

                            </div>
                            {/* <Form.Item name="purchaseGroup" label="Purchase Group" rules={[{ required: true, message: 'Please select purchase groups' }]}>
                                <Select mode="multiple" value={selectedPurchaseGroup} onChange={handlePurchaseGroupChange} optionFilterProp="key">
                                    {purchaseGroup.map((Purchase) => (
                                        <option key={Purchase.name} value={Purchase.id}>
                                            {Purchase.name}
                                        </option>
                                    ))}
                                </Select>
                            </Form.Item> */}
                            <div className='user_selectfields'>
                                <span className='requiredStar'>* </span><label className='userSelectLabels'>Purchase Group</label>
                                <Select mode="multiple" value={selectedPurchaseGroup} onChange={handlePurchaseGroupChange} optionFilterProp="key">
                                    <option key="all" value="all">
                                        {selectedPurchaseGroup?.length === purchaseGroup?.length ? 'Un Select All' : 'Select All'}
                                    </option>
                                    {purchaseGroup.map((Purchase) => (
                                        <option key={Purchase.name} value={Purchase.id}>
                                            {Purchase.name}
                                        </option>
                                    ))}
                                </Select>
                                {purchaseerrorMessage && <div style={{ color: 'red', marginTop: 5 }}>{purchaseerrorMessage}</div>}

                            </div>

                            <Form.Item name="lineItemsDeleteAccess" label="Line Item Delete Access" rules={[{ required: true }]}>
                                <Radio.Group>
                                    <Radio value="true">Yes</Radio>
                                    <Radio value="false">No</Radio>
                                </Radio.Group>
                            </Form.Item>

                            <Form.Item name="duplicateInvoiceDeleteAccess" label="Duplicate Invoice Delete Access" rules={[{ required: true }]}>
                                <Radio.Group>
                                    <Radio value="true">Yes</Radio>
                                    <Radio value="false">No</Radio>
                                </Radio.Group>
                            </Form.Item>

                            <Form.Item name="status" label="Status" rules={[{ required: true, message: 'Please select a status' }]}>
                                <Radio.Group>
                                    <Radio value="Active">Active</Radio>
                                    <Radio value="Inactive">Inactive</Radio>
                                </Radio.Group>
                            </Form.Item>

                            <Form.Item>
                                <Button type="primary" htmlType="submit">
                                    {id ? 'Update User' : 'Add User'}
                                </Button>
                                <Button onClick={() => navigate('/user-list')} style={{ marginLeft: 8 }}>
                                    Cancel
                                </Button>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
            </Card>
        </>
    );
};

export default AddEditUser;